import PieChart, { ChartProps } from "@/components/charts/PieChart";
import Table, { ColumeDef } from "@/components/shared/Table";
import { } from "@/api/query/usePortfolioDashboardQuery";
import useProjectManagerPortfolioDashboardQuery, {
  managerDashboardPortfolioDataType,
} from "@/api/query/useProjectManagerPortfolioDashboardQuery";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import HorizontalBarChart from "@/components/charts/HorizontalBarChart";
import { Button } from "@/components/ui/button";
import dateFormater from "@/helperFuntions/dateFormater";
import CreateUpdateProjectForm from "@/components/project/CreateProjectForm";
import useProjectQuery, { Program, Project } from "@/api/query/useProjectQuery";
import LinkArrow from "@/assets/svg/linkArrow.svg";
import {
  PlanTypeEnumSchema,
  ProjectBudgetEnumValue,
  ProjectStatusEnumValue,
  // UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { toast } from "react-toastify";
import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import InfoCircle from "@/assets/svg/Info circle.svg";
// import PercentageCircle from "@/components/shared/PercentageCircle";
// import UserAvatar from "@/components/ui/userAvatar";
import Loader from "@/components/common/Loader";
import { useUser } from "@/hooks/useUser";
import ActiveIcon from "@/assets/svg/ActiveIcon.svg";
import Closed from "@/assets/svg/Closed.svg";
import NotStarted from "@/assets/svg/NotStarted.svg";
import OnHold from "@/assets/svg/OnHold.svg";
import { useTranslation } from "react-i18next";
// import { usePlanValidation } from "@/hooks/usePlan";
import Select from "react-select";
import useAllPortfoliosQuery, {
  Portfolios,
} from "@/api/query/useAllPortFoliosQuery";
import useDebounce from "@/hooks/useDebounce";
import PercentageCircle from "@/components/shared/PercentageCircle";
import { calculateSPI, ProjectNode } from "@/helperFuntions/projectherarch";

export interface ProjectType {
  projectId: string;
  organisationId: string;
  projectName: string;
  projectDescription: string;
  startDate: string;
  estimatedEndDate: string;
  status: string;
  defaultView: string;
  timeTrack: string;
  budgetTrack: string;
  currency: string;
  overallTrack: string;
  estimatedBudget: string;
  actualCost: string;
  createdByUserId: string;
  updatedByUserId: string;
  createdAt: string;
  updatedAt: string;
}
export interface tableDataType {
  organisationId: string;
  organisationName: string;
  industry: string;
  status: string;
  country: string;
  nonWorkingDays: string[];
  createdAt: string;
  updatedAt: string;
  tenantId: string;
  createdByUserId: string;
  updatedByUserId: string;
  projects: ProjectType[];
}
interface ColorMapping {
  [key: string]: string;
}
type Options = { label: string; value: string };
const reactSelectStyle = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "1px solid #E7E7E7",
    paddingTop: "0.1rem",
    paddingBottom: "0.1rem",
    zIndex: 1000,
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: state.isFocused ? "1px solid #299d91" : "1px solid #E7E7E7",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
};
function ManagerDashboard() {
  const [portfolio, setPortfolio] = useDebounce(
    {
      programId: "",
      portfolioId: "",
    },
    400
  );

  const projectManagerPortfolioDashboardQuery =
    useProjectManagerPortfolioDashboardQuery(portfolio);
  const { t, i18n } = useTranslation();

  const [data, setData] = useState<managerDashboardPortfolioDataType>();
  const [statusPieChartProp, setstatusPieChartProp] = useState<ChartProps>();
  const [tableData, setTableData] = useState<ProjectType[]>();
  const [isOpenPopUp, setIsOpenPopUp] = useState(false);
  const [editData, setEditData] = useState<Project | undefined>();
  const [spiPieChartProp, setSpiPieChartProp] = useState<ChartProps>();

  const { user } = useUser();
  const [overallStatusPieChartProp, setOverallStatusPieChartProp] =
    useState<ChartProps>();
  const navigate = useNavigate();
  // const { validatePlan } = usePlanValidation();

  const formatStatus = (status: string): string => {
    return status
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };
  useEffect(() => {
    user?.userOrganisation.length == 0 ? navigate("/organisation") : "";
  }, [user]);
  const projectQuery = useProjectQuery();
  const [Spi, setSpi] = useState(0);

  useEffect(() => {
    const dashbordData =
      projectManagerPortfolioDashboardQuery?.data?.data?.data;
    setData(dashbordData);
    i18n.on("languageChanged", () => {
      setData(dashbordData);
    });
    const spi = calculateSPI(
      (dashbordData?.projects as unknown as ProjectNode[]) ?? []
    );
    setSpi(spi);
  }, [projectManagerPortfolioDashboardQuery?.data?.data?.data]);
  useEffect(() => {
    projectManagerPortfolioDashboardQuery.refetch();
  }, [projectQuery.isRefetching]);

  useEffect(() => {
    projectManagerPortfolioDashboardQuery.refetch();
  }, [portfolio]);
  useEffect(() => {
    // if (
    //   data?.projects.some((d) =>
    //     d.assignedUsers.some(
    //       (u) => u.projectRole !== UserRoleEnumValue.PROJECT_MANAGER
    //     )
    //   )
    // ) {
    //   navigate("/mytasks");
    // }
    const getTime = localStorage.getItem("dontShowPopup");
    const currentDate = new Date().getTime();
    const differenceInMs = currentDate - Number(getTime);
    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
    if (
      tableData &&
      tableData?.length >= 1 &&
      user?.subscription &&
      user?.subscription?.planType !== PlanTypeEnumSchema.FREE
    ) {
      if (differenceInDays >= 30) {
        if (!toast.isActive("toast1")) {
          toast.warning(
            <>
              <p className="w-[71ch] text-wrap">
                {t("portfolio_dashboard_warning_popup")}
                <br />
              </p>
              <div className="flex justify-end items-center">
                <button
                  onClick={dontShowPopup}
                  className="border-b border-b-white outline-none mt-1 text-xs ml-auto"
                >
                  {t("not_visible_for_30_days")}
                </button>
              </div>
            </>,
            {
              autoClose: false,
              closeOnClick: false,
              className: "bg-primary-400 w-fit  text-nowrap !text-white",
              bodyClassName: "text-white",
              style: { left: "25%", top: 10 },
              toastId: "toast1",
            }
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    setTableData(data?.projects);
    const statusPieChartData: ChartProps["chartData"] = [];
    data?.CPIDataResponse?.CPILabels?.forEach((name: string, index) => {
      if (Number(data?.CPIDataResponse?.CPIdata[index]) > 0) {
        
        statusPieChartData.push({
          value: Number(data?.CPIDataResponse?.CPIdata[index]),
          name: name,
          subText:
            name === "SIGNIFICANT_BUDGET"
              ? "SIGNIFICANT_BUDGET_PIE_TOOLTIP"
              : name === "MODERATE_BUDGET"
                ? "MODERATE_BUDGET_PIE_TOOLTIP"
                : name === "ON_BUDGET"
                  ? "ON_BUDGET_PIE_TOOLTIP"
                  : "",
        });
      }
    });
  
    // const statusPieChartDatacolors = [
    //   { ACTIVE: "#68B266" },
    //   { CLOSED: "#333333" },
    //   { NOT_STARTED: "#636363" },
    //   { ON_HOLD: "#784BD1" },
    // ].map((obj) => {
    //   const key = Object.keys(obj)[0] as keyof typeof obj;
    //   const value = obj[key];
    //   return { [t(key)]: value ?? "" };
    // });
    const BudgetPieChartDatacolors = [
      { "SIGNIFICANT_BUDGET": "#EA4335" },
      { "MODERATE_BUDGET": "#ff7600" },
      { "ON_BUDGET": "#68B266" },
      { "UNDER_BUDGET": "#254b24" },
    ].reduce((acc, obj) => {
      const [key, value] = Object.entries(obj)[0];
      acc[key] = value;
      return acc;
    }, {} as ColorMapping);
    
    const colors = statusPieChartData.map(
      (obj) => BudgetPieChartDatacolors[obj.name] ?? "#000000"
    );
    
  
    
    setstatusPieChartProp({
      chartData: statusPieChartData.map(({ value, name, subText }) => ({
        value,
        name:
          name === "SIGNIFICANT_BUDGET"
            ? t("SIGNIFICANT_BUDGET")
            : name === "MODERATE_BUDGET"
              ? t("MODERATE_BUDGET")
              : name === "ON_BUDGET"
                ? t("ON_BUDGET")
                : t("UNDER_BUDGET"),
        subText: subText && t(subText),
      })),
      color: colors,
      title: t("projects_per_budget"),
      radius: ["0%", "60%"],
      height: "300px",
      hoverText: "Are",
    });
    const overallSituationPieChartData: ChartProps["chartData"] = [];
    data?.overallSituationChartData?.labels.forEach((name: string, index) => {
      if (Number(data?.overallSituationChartData?.data[index]) > 0) {
        overallSituationPieChartData.push({
          value: Number(data?.overallSituationChartData?.data[index]),
          name: t(name),
        });
      }
    });
    const OverallStatusPieChartColor: ColorMapping[] = [
      { CLOUDY: "#636363" },
      { STORMY: "#4B0082" },
      { SUNNY: "#FBBC05" },
      { RAINY: "#4682B4" },
    ].map((obj) => {
      const key = Object.keys(obj)[0] as keyof typeof obj;
      const value = obj[key];
      return { [t(key)]: value ?? "" };
    });

    // = OverallStatusPieChartColor.filter((e) => {
    //   const key = Object.keys(e)[0];
    //   return overallSituationPieChartData.some((r) => r.name === key);
    // })

    const filteredColors = OverallStatusPieChartColor.reduce(
      (acc: ColorMapping, curr) => {
        const [key, value] = Object.entries(curr)[0];
        acc[key] = value;
        return acc;
      },
      {} as ColorMapping
    );

    const resultColors = overallSituationPieChartData
      .map((obj) => Object.values(obj)[1])
      .map((weather) => filteredColors[weather]);

    setOverallStatusPieChartProp({
      chartData: overallSituationPieChartData!,
      color: [...resultColors],
      title: t("projects_per_overall_situation"),
      radius: ["0%", "60%"],
      height: "300px",
      hoverText: "Are",
    });

    const statusColorMap: Record<string, string> = {
      "Significant Delay": "#EA4335",
      "Moderate Delay": "#FFA500",
      "On Time": "#68B266",
      "Ahead Of Schedule":"#254b24",
    };

    const spiPieChartData = (data?.spiData?.labels || []).reduce<
      {
        value: number;
        name: string;
        rawStatus: string;
        subText: string;
      }[]
    >((acc, name, index) => {
      const value = Number(data?.spiData?.data[index]);
      if (value > 0) {
        acc.push({
          value,
          name: t(formatStatus(name).replaceAll(" ", "_").toUpperCase()),
          rawStatus: formatStatus(name), // Keep original English text
          subText:
            t(formatStatus(name).replaceAll(" ", "_").toUpperCase()) ===
            t("SIGNIFICANT_DELAY")
              ? t("SIGNIFICANT_DELAY_PIE_TOOLTIP")
              : t(formatStatus(name).replaceAll(" ", "_").toUpperCase()) ===
                t("MODERATE_DELAY")
                ? t("MODERATE_DELAY_PIE_TOOLTIP")
                : t(formatStatus(name).replaceAll(" ", "_").toUpperCase()) ===
                t("ON_TIME")
                  ? t("ON_TIME_PIE_TOOLTIP")
                  : "",
        });
      }
      return acc;
    }, []);

    const spiFilteredColors = spiPieChartData.map((item) => {
      const color = statusColorMap[item.rawStatus] || "#000000"; // fallback color if not found
      return color;
    });

    setSpiPieChartProp({
      chartData: spiPieChartData.map(({ value, name, subText }) => ({
        value,
        name,
        subText,
      })), // remove rawStatus
      color: spiFilteredColors,
      title: t("project_with_delays"),
      radius: ["0%", "60%"],
      height: "300px",
      hoverText: "Have",
    });
  }, [data, i18n.language]);
  const dontShowPopup = () => {
    localStorage.setItem("dontShowPopup", new Date().getTime().toString());
    toast.dismiss("toast1");
  };

  // const chartProp2: ChartProps = {
  //   chartData: [],
  //   color: ["#FFD04A", "#FFB819", "#B74E06"],
  //   title: "Project With Delays",
  //   radius: ["45%", "60%"],
  //   height: "300px",
  // };

  // const chartProp4: ChartProps = {
  //   chartData: [],
  //   color: ["#FFD04A", "#FFB819", "#B74E06"],
  //   title: "Projects Per Severity",
  //   radius: ["70%", "80%"],
  //   height: "500px",
  // };
  // const chartProp5: ChartProps = {
  //   chartData: [],
  //   color: ["#FFD04A", "#FFB819", "#B74E06"],
  //   title: "Risks",
  //   radius: ["70%", "80%"],
  //   height: "500px",
  // };
  const columnDef: ColumeDef[] = [
    {
      key: "projectName",
      header: t("project_name"),
      sorting: true,
      onCellRender: (projectData) => {
        return (
          <div className="w-full text-left">
            {projectData.isActive ? (
              <Link
                className="text-primary-500 underline"
                to={"/projectDashboard/" + projectData?.projectId}
              >
                {projectData.projectName}
              </Link>
            ) : (
              <div className="text-gray-500">{projectData.projectName}</div>
            )}
          </div>
        );
      },
    },
    {
      key: "progressionPercentage",
      header: "Progress",
      sorting: true,
      onCellRender: (item: Project) => {
        // This cell now renders progress for all hierarchy item types
        let spiColor = "#68B266"; // Default green color
        if (item.tasks?.length > 0) {
          if (typeof item.spi === "number") {
            const uniqueFlags = new Set(item.tasks.map((t) => t.flag));

            if (uniqueFlags.size === 1) {
              const onlyFlag = uniqueFlags.values().next().value;
              const flagColorMap: Record<string, string> = {
                Green: "#68B266",
                Red: "#EA4335",
                Orange: "#FFA500", // Or "Orange" if that's the correct flag
              };

              spiColor = flagColorMap[onlyFlag as string] ?? "#68B266"; // Default to green if flag is unrecognized
            } else {
              const spi = item.spi;

              spiColor =
                spi < 80
                  ? "#EA4335" // Red
                  : spi < 95
                    ? "#FFA500" // Orange
                    : "#68B266"; // Green
            }
          } else {
            spiColor =
              Number((item as any)?.progress) < 25
                ? "#EA4335"
                : Number((item as any)?.progress) >= 25 &&
                  Number((item as any)?.progress) < 50
                  ? "#FFA500"
                  : Number((item as any)?.progress) >= 50 &&
                  Number((item as any)?.progress) < 75
                    ? "#4169E1"
                    : Number((item as any)?.progress) >= 75 &&
                  Number((item as any)?.progress) <= 100
                      ? "#68B266"
                      : "#EA4335";

            // Default color for non-project items
          }
        } else {
          const todayDate = new Date();
          const projectStartDate = new Date(item.startDate ?? "");
          if (projectStartDate < todayDate) {
            spiColor = "#EA4335";
          }
        }

        return (
          <div>
            <PercentageCircle
              percentage={Number(item.progressionPercentage) * 100} // Use the calculated progress for all types
              roundColor={spiColor}
            />
          </div>
        );
      },
    },
    {
      key: "spi",
      header: t("spi"),
      sorting: true,
      onCellRender: (item: Project) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1  items-center">
                {item.spi ? item.spi.toFixed() : (0).toFixed()}%
                <img
                  src={InfoCircle}
                  className="min-w-4 w-4 brightness-0 invert"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm  h-full text-center text-wrap">
                  {item.spi ? item.spi.toFixed(4) : (0).toFixed(4)}%
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </>
      ),
      onHeaderRender: (item: string) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1  items-center">
                {t(item)}
                <img
                  src={InfoCircle}
                  className="min-w-4 w-4 brightness-0 invert"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm w-96 h-full text-center text-wrap">
                  {t("spi_tooltip")}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </>
      ),
    },
    {
      key: "cpi",
      header: t("cpi"),
      sorting: true,
      onCellRender: (item: Project) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1 items-center w-fit">
                {item.cpi ? item.cpi.toFixed() : (0).toFixed()}%
                <img
                  src={InfoCircle}
                  className="min-w-4 w-4 brightness-0 invert"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm text-center text-wrap">
                  {item.cpi ? item.cpi.toFixed(4) : (0).toFixed(4)}%
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>{" "}
        </>
      ),
      onHeaderRender: (item: string) => (
        <>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="flex gap-1 items-center w-fit">
                {t(item)}
                <img
                  src={InfoCircle}
                  className="min-w-4 w-4 brightness-0 invert"
                  alt="InfoCircle"
                />
              </TooltipTrigger>
              <TooltipContent>
                <p className="text-sm w-96 text-center text-wrap">
                  {t("CPI_description")}
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </>
      ),
    },

    {
      key: "startDate",
      header: t("start_date"),
      sorting: true,
      onCellRender: (item) => <>{dateFormater(new Date(item.startDate))}</>,
    },
    {
      key: "estimatedEndDate",
      header: t("estimated_end_date"),
      sorting: true,
      onCellRender: (item) => (
        <>
          {item.estimatedEndDate
            ? dateFormater(new Date(item.estimatedEndDate))
            : "N/A"}
        </>
      ),
    },
    {
      key: "actualEndDate",
      header: t("actual_end_date"),
      sorting: true,
      onCellRender: (item) => (
        <>
          {item.estimatedEndDate
            ? dateFormater(new Date(item.actualEndDate))
            : "N/A"}
        </>
      ),
    },
    {
      key: "status",
      header: t("status"),
      sorting: true,
      onCellRender: (item: Project) => (
        <>
          <div
            className={`w-32 h-8 px-3 py-1.5 ${getStatusColor(
              item.status
            )} rounded justify-center items-center gap-px inline-flex`}
          >
            <div className=" text-xs font-medium leading-tight">
              {item.status
                .toLowerCase()
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </div>
          </div>
        </>
      ),
    },
    {
      key: "estimatedBudget",
      header: t("estimated_budget"),
      sorting: true,
    },
    {
      key: "consumedBudget",
      header: t("consumed_budget"),
      sorting: true,
    },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
    case ProjectBudgetEnumValue.PROJECT_IS_SIGNIFICANTLY_OVER_BUDGET:
      return "!bg-status-gray text-white";
    case ProjectBudgetEnumValue.PROJECT_IS_MODERATELY_OVER_BUDGET:
      return "!bg-status-purple text-white";
    case ProjectBudgetEnumValue.PROJECT_IS_ON_BUDGET:
      return "!bg-status-green text-white";
    case ProjectBudgetEnumValue.PROJECT_IS_UNDER_BUDGET:
      return "!bg-status-black text-white";
    }
  };

  const close = () => {
    setIsOpenPopUp(false);
    setEditData(undefined);
  };
  const filterRoutes = (item: string) => {
    navigate(`/projects/?status=${item}`);
  };

  const imageReturn = (type: string) => {
    switch (type) {
    case ProjectStatusEnumValue.ACTIVE:
      return <img className="h-6 min-h-6" src={ActiveIcon} />;
    case ProjectStatusEnumValue.CLOSED:
      return <img className="h-6 min-h-6" src={Closed} />;
    case ProjectStatusEnumValue.NOT_STARTED:
      return <img className="h-6 min-h-6" src={NotStarted} />;
    case ProjectStatusEnumValue.ON_HOLD:
      return <img className="h-6 min-h-6" src={OnHold} />;
    }
  };
  const [allPortfolios, setAllPortfolios] = useState<{
    programs: Program[];
    portfolios: Portfolios[];
  }>();
  const allPortfoliosQuery = useAllPortfoliosQuery();
  const [portfolios, setPortfolios] = useState<Options[]>([]);
  const [programs, setPrograms] = useState<Options[]>([]);
  useEffect(() => {
    const data = allPortfoliosQuery.data?.data.data;
    setAllPortfolios(data);
    setPortfolios([
      { label: t("Select portfolio"), value: "" },
      ...(data?.portfolios ?? []).map(({ portfolioId, portfolioName }) => ({
        value: portfolioId,
        label: portfolioName,
      })),
    ]);
  }, [allPortfoliosQuery.data?.data.data, t]);
  useEffect(() => {
    const selectedPortfolio = allPortfolios?.portfolios.find(
      ({ portfolioId }) => portfolioId == portfolio?.portfolioId
    );
    setPortfolio((prev) => {
      return { ...prev, programId: "" };
    });
    if (selectedPortfolio && selectedPortfolio?.programs?.length) {
      setPrograms([
        { label: t("Select program"), value: "" },
        ...(selectedPortfolio?.programs?.map(({ programId, programName }) => ({
          value: programId,
          label: programName,
        })) ?? []),
      ]);
    } else {
      setPrograms([
        { label: t("Select program"), value: "" },
        ...(allPortfolios?.programs?.map(({ programId, programName }) => ({
          value: programId,
          label: programName,
        })) ?? []),
      ]);
    }
  }, [
    portfolio.portfolioId,
    allPortfoliosQuery.data?.data.data,
    allPortfolios,
  ]);

  return (
    <>
      {(projectManagerPortfolioDashboardQuery.isFetching ||
        projectManagerPortfolioDashboardQuery.isRefetching) && (
        <Loader className="absolute left-0 top-0 bg-slate-50" />
      )}

      <div className="overflow-auto w-full py-2 px-8 flex flex-col gap-4">
        <div className="w-full h-fit flex flex-col gap-2 ">
          <div className="flex gap-2 items-center justify-between w-full my-2">
            <div className="text-xl font-bold text-gray-400">
              {t("project_status")}
            </div>
            <div className="flex gap-2 items-center">
              <Select
                className="w-52 z-[1]"
                placeholder="Select Portfolio"
                options={portfolios}
                value={portfolios.find((t) => t.value == portfolio.portfolioId)}
                onChange={(e) => {
                  const val = e as Options;
                  if (val) {
                    setPortfolio((prev) => {
                      return { ...prev, portfolioId: val.value };
                    });
                  } else {
                    setPortfolio((prev) => {
                      return { ...prev, portfolioId: "" };
                    });
                  }
                }}
                styles={reactSelectStyle}
              ></Select>
              <Select
                className="w-52 z-[1]"
                placeholder="Select Program"
                options={programs}
                value={programs.find((t) => t.value == portfolio.programId)}
                onChange={(e) => {
                  const val = e as Options;
                  if (val) {
                    setPortfolio((prev) => {
                      return { ...prev, programId: val.value };
                    });
                  } else {
                    setPortfolio((prev) => {
                      return { ...prev, programId: "" };
                    });
                  }
                }}
                styles={reactSelectStyle}
              ></Select>
              {(portfolio.portfolioId || portfolio.programId) && (
                <Button
                  variant={"secondary"}
                  onClick={() => {
                    setPortfolio({
                      portfolioId: "",
                      programId: "",
                    });
                  }}
                >
                  {t("clear")}
                </Button>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-5 w-full">
            <div className="progress w-full h-full flex flex-col justify-between relative items-center gap-1 py-2 border-2 border-gray-450/50 rounded-xl">
              <div className="text-xl font-thin text-gray-450/80  mt-3">
                {t("portfolio_progress")}
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger className="flex gap-1 items-center absolute top-1 right-1">
                      <img
                        src={InfoCircle}
                        className="h-[16px] w-[16px] brightness-0"
                        alt="InfoCircle"
                      />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="text-sm text-center w-96">
                        {t("Portfolio_progress_tooltip")}
                        <hr className="h-px my-2 bg-gray-200 border-0 " />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: t("Portfolio_Progress_formula"),
                          }}
                        ></div>
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
              {}
              <PercentageCircle
                percentage={data?.portfolioPercentage ?? 0}
                className="my-3"
                roundColor={
                  Spi < 80
                    ? "#EA4335" // Red
                    : Spi < 95
                      ? "#FFA500" // Orange
                      : "#68B266"
                }
              />
            </div>
            {data?.statusChartData?.labels.map((labelData, index) => (
              <>
                <div
                  key={index}
                  className={` w-full p-5 py-3 md:mt-0 mt-2 rounded-xl text-white ${
                    labelData === ProjectStatusEnumValue.ACTIVE
                      ? "bg-flag-green"
                      : labelData === ProjectStatusEnumValue.ON_HOLD
                        ? "bg-[#784BD1]"
                        : labelData === ProjectStatusEnumValue.NOT_STARTED
                          ? "bg-gray-450"
                          : "bg-gray-900"
                  }`}
                >
                  {imageReturn(labelData)}
                  <div className="flex flex-col gap-2 mt-2">
                    <a className="text-xl font-thin items-end">
                      {t(labelData)}
                    </a>
                    <div className="flex justify-between items-center w-full">
                      <a className="text-3xl font-semibold">
                        {data?.statusChartData?.data[index]}
                      </a>{" "}
                      <img
                        className=" brightness-0 invert h-5 w-5 opacity-50 hover:opacity-100 cursor-pointer"
                        onClick={() => filterRoutes(labelData)}
                        src={LinkArrow}
                      />
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
        <div className=" w-full h-fit flex flex-col justify-center mt-2 ">
          <div className="text-xl font-bold text-gray-400 ">{t("charts")}</div>
          <div className="flex flex-col lg:flex-row justify-center items-center w-full  gap-14 py-2 ">
            <div className="situation rounded-2xl w-3/4 lg:w-2/6 h-full justify-center items-center flex gap-2 backdrop-filter backdrop-blur-md bg-opacity-60 border border-gray-300">
              <PieChart chartProps={overallStatusPieChartProp!} />
            </div>
            <div className="delays rounded-2xl w-3/4 lg:w-2/6 h-fit justify-center items-center flex gap-2 backdrop-filter backdrop-blur-md bg-opacity-60 border border-gray-300">
              <PieChart chartProps={spiPieChartProp!} />
            </div>

            <div className="status rounded-2xl w-3/4 lg:w-2/6  h-fit justify-center items-center flex gap-2 backdrop-filter backdrop-blur-md bg-opacity-60 border border-gray-300  ">
              <PieChart chartProps={statusPieChartProp!} />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col md:flex-col gap-2 justify-center px-5 md:px-20 lg:px-0 self-center">
          {/* <div className="w-full  self-center flex justify-end">
            {user?.userOrganisation[0]?.role ==
              UserRoleEnumValue.ADMINISTRATOR && (
              <Button
                variant={"primary"}
                onClick={() => {
                  if (validatePlan("project").valid) {
                    setIsOpenPopUp(true);
                  }
                }}
              >
                {t("add_project")}
              </Button>
            )}
          </div> */}

          <div className="w-full h-full self-center mb-10">
            {tableData && (
              <>
                <Table
                  key="ProjectList view"
                  columnDef={columnDef}
                  data={tableData}
                  className="!px-0"
                  onRowClassName={(data) => {
                    return !data.isActive
                      ? "opacity-70 bg-gray-400/30 cursor-not-allowed"
                      : "";
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {isOpenPopUp && (
        <CreateUpdateProjectForm handleClosePopUp={close} editData={editData} />
      )}
    </>
  );
}
export default ManagerDashboard;
